
document.addEventListener("DOMContentLoaded", function(event) {
  var delayInMilliseconds = 1000; 
  var delayInMilliseconds2 = 1700; 
  
  setInterval(function() {

   const element1 = document.getElementsByClassName('appstle_subscription_wrapper_option')[0];
   const element2 = document.getElementsByClassName('appstle_subscription_wrapper_option')[1];
   const taxtext = document.getElementById('taxtext');
   taxtext.innerHTML="(27p per serving)";


  
  if(element1.classList.contains('appstle_selected_background'))
  {
    console.log("second option selected");
    taxtext.innerHTML="(32p per serving)";
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    const subsavetext = document.getElementsByClassName('appstle_subscribe_save_text')[0];
    subsavetext.textContent = "Subscribe & Save";
    }
  }
  else{
    console.log("first option selected");
    taxtext.innerHTML="(27p per serving)";
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    const subsavetext = document.getElementsByClassName('appstle_subscribe_save_text')[0];
    subsavetext.textContent = "Subscribe & Save";
    }
  }


  
}, delayInMilliseconds);

  

  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {



    
    setInterval(function() {
     console.log("setintervall");
        const subsavetext = document.getElementsByClassName('appstle_subscribe_save_text')[0];
        subsavetext.textContent = "Subscribe & Save";

      


  }, 1000); 



         subsavetext.addEventListener('DOMSubtreeModified', function() {
        subsavetext.textContent = "Subscribe & Save";
        console.log("subsave text updated");
});
  }






  setTimeout(function() {
   const element1 = document.getElementsByClassName('appstle_subscription_wrapper_option')[0];
   const element2 = document.getElementsByClassName('appstle_subscription_wrapper_option')[1];
  element1.classList.remove("appstle_selected_background");
    console.log("class removed");
  
}, delayInMilliseconds2);
  

  



  
});





